/**
 * Created by Udara Prabath
 * Date: 11/2/2020
 * Using: IntelliJ IDEA
 */

import React from "react";
import './ViewLesson.scss';
import * as constants from "../../../../const/constants";
import {BOUGHT_TEXT, BUY_TEXT, PENDING_TEXT, RE_BUY_TEXT} from "../../../../const/constants";
import CardsFooter from "../../../../components/Modals/Footers/CardsFooter";
import {lang, language} from "../../../../const/language";
import {Button, Col, Container, Row} from "reactstrap";
import {Modal} from "semantic-ui-react";
import 'vimond-replay/index.css';
import i from "react-icofont";
import * as actionModalCreator from "../../../../store/domain/modal/action";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import * as actionSpinnerCreator from "../../../../store/domain/spinner/action";
import * as lessonService from "../../../../services/lessons";
import * as commonFunc from "../../../../utils/commonFunc";
import NotFound from "../../../../components/NotFound/NotFound";
import swal from "sweetalert";
import moment from "moment";
import NewVideoPlayer from "../../../../components/VideoPlayer/NewVideoPlayer";
import {isBrowser, isMobile} from "react-device-detect";
import ViberHeader from "../../../../components/header-new/ViberHeader";
import ReactPlayer from "react-player";
import CustomYoutubePlayer from "../../../../components/CustomYoutubePlayer/CustomYoutubePlayer";


class ViewLesson extends React.Component {

    state = {
        lesson: undefined,
        videos: [],
        pdfs: [],
        selectedVideo: null,
        videoModal: false,
        videoType: '',
        CountLimitation: false,
        selectedItem: null,
        isValidCount: false
    }

    // constructor(props) {
    //     super(props);
    //     this.iframeRef = React.createRef(); // Create a ref for the iframe
    // }


    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
    }

    async UNSAFE_componentWillMount() {
        let state = this.props.location.state;
        console.log(state)
        if (state) {
            const videos = [], pdfs = [];
            state.contents.map(item => {
                if (item.type === 'PDF') {
                    pdfs.push(item)
                } else {
                    videos.push((item));
                }
            });

            await this.setState({
                lesson: state,
                videos: videos,
                pdfs: pdfs,
            })
        } else {
            this.props.history.push(`${constants.BASE_ROUTE}${constants.HOME_MY_CLASS_ROUTE}`);
        }
    }

    purchaseHandler = (lessonId) => {
        this.props.setPaymentModal(true, {lessonId: lessonId})
    };


    onVideoClick = async (id, type, count) => {
        this.setState({
            videoType: type
        })
        this.props.spinnerHandler(true);
        if (count === -1) {
            await this.getVideo(id, type);
        } else {
            if (this.state.lesson.firstWeek) {
                await this.getVideo(id, type);
            } else {
                await lessonService.getContentCount(id)
                    .then(res => {
                        this.props.spinnerHandler(false);
                        if (res.success) {
                            console.log("Count", res.body)
                            swal({
                                title: constants.ALERT_TEXT_VIDEO,
                                text: language[lang].remaining + res.body.count,
                                icon: null,
                                closeOnClickOutside: false,
                                buttons: {
                                    cancel: language[lang].NoText,
                                    dangerMode: {text: language[lang].YesText, value: "action", className: "okay-btn"}
                                },
                            }).then(async (value) => {
                                switch (value) {
                                    case "action":
                                        this.props.spinnerHandler(true);
                                        await this.getVideo(id, type);
                                        break;
                                    default:
                                        break;
                                }
                            });
                        } else {
                            commonFunc.notifyMessage(res.message);
                        }
                    })
                    .catch(error => {
                        this.props.spinnerHandler(false);
                        commonFunc.notifyMessage(error.message, error.status);
                    })
            }
        }
    }


    getVideo = async (id, type) => {
        await lessonService.getVideoUrl(id, this.state.lesson.classId ? this.state.lesson.classId : 0)
            .then(res => {
                this.props.spinnerHandler(false);
                if (res.success) {
                    this.setState({isValidCount: true})
                    if (type === 'ZOOM') {
                        if (isMobile) {
                            // window.open(res.body);
                        } else if (isBrowser) {
                            // window.open(res.body);
                        }
                    } else {
                        // this.setState({
                        //     videoModal: true,
                        //     selectedVideo: res.body,
                        // });
                    }

                } else {
                    commonFunc.notifyMessage(res.message);
                }
            })
            .catch(error => {
                this.props.spinnerHandler(false);
                commonFunc.notifyMessage(error.message, error.status);
            })
    }

    // Function to request fullscreen
    // requestFullScreen = () => {
    //     const iframe = this.iframeRef.current;
    //     if (iframe.requestFullscreen) {
    //         iframe.requestFullscreen();
    //     } else if (iframe.mozRequestFullScreen) { // Firefox
    //         iframe.mozRequestFullScreen();
    //     } else if (iframe.webkitRequestFullscreen) { // Chrome, Safari, Opera
    //         iframe.webkitRequestFullscreen();
    //     } else if (iframe.msRequestFullscreen) { // IE/Edge
    //         iframe.msRequestFullscreen();
    //     }
    // };

    toggle = () => this.setState({videoModal: !this.state.videoModal});

    closeVideoModal = () => {
        this.setState({
            selectedItem: null,
            isValidCount: false
        })
    }

    render() {
        const lesson = this.state.lesson;
        console.log(lesson)


        return (
            <div>
                {/*<Header/>*/}
                <ViberHeader/>
                <main ref="main" className={"viewLesson"}>

                    <div className="backBtnHolder">
                        <button className={"home-btn"}
                                onClick={() => window.history.back()}>
                            <i className="icofont-long-arrow-left"/>
                            {language[lang].BackToTour}
                        </button>
                    </div>
                    <div className="trapezoid "></div>

                    <>
                        {
                            lesson &&
                            <Container>
                                <Row>
                                    <Col md={8} className="mt-3">
                                        <div>
                                            <p className={"head-topic"}>{lesson.name}</p>
                                            <p className={"head-description"}>{lesson.description}</p>
                                            <p className={"head-qty"}>
                                                <i className="icofont-video mr-1"/>{language[lang].noOfVideos} : {this.state.videos.length}
                                            </p>
                                            <p className={"head-qty"}><i
                                                className="icofont-eye-open mr-1"/>
                                                {
                                                    lesson.expireDateTime === null ?
                                                        language[lang].noOfValidityDays + ' : ' + lesson.validityDays :
                                                        language[lang].validForClass + ' : ' +
                                                        moment(lesson.expireDateTime.split('T')[0]).format('YYYY-MMM-DD')
                                                }

                                                {/*{language[lang].noOfValidityDays} : &nbsp;*/}
                                                {/*{lesson.validityDays === 0 ? language[lang].validForClass : lesson.validityDays}*/}
                                            </p>
                                        </div>
                                    </Col>
                                    <Col md={4} className="mt-3">
                                        {/*<Replay*/}
                                        {/*    source={lesson.previewVideo}*/}
                                        {/*    initialPlaybackProps={{isPaused: true}}*/}
                                        {/*>*/}
                                        {/*    <HlsjsVideoStreamer/>*/}
                                        {/*</Replay>*/}
                                        {}
                                        {/*<VideoPLayer video={lesson.previewVideo}/>*/}
                                        <NewVideoPlayer url={lesson.previewVideo}/>
                                    </Col>

                                    {
                                        lesson.btnStatus === BUY_TEXT ?
                                            <Col md={12} className="btnHolder mt-3 mb-3">
                                                <div align='right'>
                                                    <Button
                                                        className={"log-btn com-btn bold-text "}
                                                        onClick={() => this.purchaseHandler(lesson.id)}
                                                        outline
                                                        color={"primary"}>{language[lang].PurchaseTheLesson}</Button>
                                                </div>
                                            </Col> :
                                            lesson.btnStatus === PENDING_TEXT ?
                                                <Col md={12} className="btnHolder mt-3 mb-3">
                                                    <div align='right'>
                                                        <Button
                                                            className={"reg-btn com-btn bold-text "}
                                                            outline
                                                            color={"primary"}>{language[lang].PaymentPending}</Button>
                                                    </div>
                                                </Col> :
                                                null
                                    }

                                    {
                                        (lesson.btnStatus === BOUGHT_TEXT || lesson.btnStatus === RE_BUY_TEXT) &&
                                        <Col md={12} className="mt-4">
                                            {
                                                this.state.videos.length !== 0 &&
                                                <>
                                                    <p className={"body-topic"}>Videos</p>
                                                    {
                                                        this.state.videos.map((item, index) => {
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => {
                                                                        this.onVideoClick(item.id, item.type, item.viewCount).then(r => {
                                                                        });
                                                                        this.setState({selectedItem: item});
                                                                    }}
                                                                    // onClick={() => this.onVideoClick(item.id,item.type,item.viewCount)}
                                                                    // onClick={()=>{window.open(item.url,"_blank")}}
                                                                    className="body-item-holder">
                                                                    <p className={"body-item"}>&nbsp;&nbsp;-&nbsp;{item.name}</p>
                                                                    {item.type === 'VIDEO' ? <p>vimeo&nbsp;&nbsp;<i
                                                                            className="icofont-eye-open mr-1"/></p>
                                                                        : item.type === 'GOOGLE_DRIVE' ?
                                                                            <p> google drive&nbsp;&nbsp;<i
                                                                                className="icofont-eye-open mr-1"/>
                                                                            </p> :
                                                                            <p> {item.type.toLowerCase()}&nbsp;&nbsp;<i
                                                                                className="icofont-eye-open mr-1"/></p>}

                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </>

                                            }

                                            {
                                                this.state.pdfs.length !== 0 &&
                                                <>
                                                    <p className={"body-topic mt-2"}>PDFs</p>
                                                    {
                                                        this.state.pdfs.map((item, index) => {
                                                            return (
                                                                <div
                                                                    key={index}
                                                                    onClick={() => window.open(item.url, '_blank')}
                                                                    className="body-item-holder">
                                                                    <p className={"body-item"}>&nbsp;&nbsp;-&nbsp;{item.name}</p>
                                                                    <i className="icofont-eye-open mr-1"/>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </>
                                            }

                                            {
                                                (this.state.pdfs.length === 0 && this.state.videos.length === 0) &&
                                                <NotFound/>
                                            }
                                        </Col>
                                    }

                                </Row>
                            </Container>
                        }
                    </>

                    {
                        this.state.selectedItem && this.state.isValidCount &&
                        <Modal
                            style={{marginLeft: '2.5vw'}}
                            closeOnEscape={true}
                            closeOnDimmerClick={false}
                            centered={true}  // Make this false, since fullscreen mode should handle positioning.
                            size="fullscreen"
                            open={!!this.state.selectedItem} // Use boolean value for open state.
                            onClose={() => this.setState({selectedItem: null, isValidCount: false})}>
                            {/*<Modal.Content>*/}
                            {/*<button onClick={this.requestFullScreen}*/}
                            {/*        style={{position: 'absolute', top: '10px', right: '10px'}}>*/}
                            {/*    Go Fullscreen*/}
                            {/*</button>*/}
                            {/*<Modal.Content>*/}

                            <div
                                onClick={() => this.closeVideoModal()}
                                style={{
                                    width: '100%',
                                    cursor: 'pointer',
                                    background: 'white', display: 'flex', justifyContent: 'flex-end'
                                }}>
                                <i style={{padding: '10px', background: '#d52f2f', color: 'wheat'}}
                                   aria-hidden="true"
                                   className="icofont-close"/>

                            </div>

                            {
                                this.state.selectedItem.type === "ZOOM" ?
                                    <iframe
                                        style={{
                                            width: '100%',
                                            height: '100vh'
                                        }}
                                        allowFullScreen
                                        src={this.state.selectedItem ? this.state.selectedItem.url : ''}
                                        title="Zoom Meeting"
                                    /> :

                                    <CustomYoutubePlayer url={this.state.selectedItem ? this.state.selectedItem.url : ''}/>

                                // <ReactPlayer
                                //     config={{
                                //         youtube: {
                                //             playerVars: {fs: 0}
                                //         }
                                //     }}
                                //     controls={true}
                                //     width={'100%'}
                                //     height={'100vh'}
                                //     url={this.state.selectedItem ? this.state.selectedItem.url : ''}/>
                            }

                            {/*</Modal.Content>*/}
                            {/*</Modal.Content>*/}
                        </Modal>

                    }


                    {/*{*/}
                    {/*    this.state.videoModal &&*/}
                    {/*    <Modal*/}
                    {/*        closeIcon*/}
                    {/*        open={this.state.videoModal}*/}
                    {/*        onClose={() => this.toggle()}*/}
                    {/*    >*/}

                    {/*        <div onClick={() => this.toggle()}*/}
                    {/*             style={{*/}
                    {/*                 width: '100%',*/}
                    {/*                 cursor: 'pointer',*/}
                    {/*                 background: 'white', display: 'flex', justifyContent: 'flex-end'*/}
                    {/*             }}>*/}
                    {/*            <i style={{padding: '10px', background: '#d52f2f', color: 'wheat'}}*/}
                    {/*               aria-hidden="true"*/}
                    {/*               className="icofont-close"/>*/}

                    {/*        </div>*/}

                    {/*        <Modal.Content>*/}
                    {/*            /!*<Replay*!/*/}
                    {/*            /!*    source={this.state.selectedVideo}*!/*/}
                    {/*            /!*    initialPlaybackProps={{isPaused: true}}*!/*/}
                    {/*            /!*>*!/*/}
                    {/*            /!*    <HlsjsVideoStreamer/>*!/*/}
                    {/*            /!*</Replay>*!/*/}
                    {/*            <Row>*/}
                    {/*                <Col md={12} className="mt-3">*/}

                    {/*                    {this.state.videoType === 'VIDEO' ?*/}
                    {/*                        <VideoPLayer lesson={true} video={this.state.selectedVideo}/> :*/}
                    {/*                        <Player type={this.state.videoType} url={this.state.selectedVideo}/>}*/}

                    {/*                </Col>*/}
                    {/*            </Row>*/}
                    {/*        </Modal.Content>*/}
                    {/*    </Modal>*/}
                    {/*}*/}

                </main>

                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
    setPaymentModal: (data, value) => dispatch(actionModalCreator.setPaymentModal(data, value)),
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ViewLesson));
